function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M4.152 11.152L5.835 9.47l4.682-4.682a.45.45 0 01.636 0l.425.424a.45.45 0 010 .636L6.895 10.53l-.72.72H20.55a.45.45 0 01.45.45v.6a.45.45 0 01-.45.45H6.175l.72.72 4.682 4.681a.45.45 0 010 .637l-.425.424a.45.45 0 01-.636 0L5.834 14.53 4.153 12.85l-.002-.002-.317-.317a.75.75 0 010-1.06l.318-.318z"
});

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
};

export default SvgArrow;